/*
 * @Description: 项目配置
 * @Date: 2021-03-22 00:21:31
 */

import { runConfig } from '@xcxConfig/run_config';

export const BASE_DOMAIN = `${window.location.protocol}//${window.location.host}`;

export const BASE_PATH = '/index.html';

export const TOKEN_KEY = 'authentication';

export const REQUEST_PATH = '/mobile-end';

export const FILE_VIEW_URL =
  '//cdn.myxrk.com/myxrk-v2/front-end/html/file-view/index.html';

export const REQUEST_DOMAIN = runConfig['run_request_domain'];

export const PLATFORM_TYPE = runConfig['platform-type'] as 1 | 2; // 平台类型，区分1向日葵平台、2独立平台

export const IS_PLATFORM_TYPE_1 = PLATFORM_TYPE === 1;

export const IS_PLATFORM_TYPE_2 = PLATFORM_TYPE === 2;

export const PLATFORM_ID = runConfig['platform-id']; // 平台\独立平台 ID，用于全局请求头，比如三个独立项目PLATFORM_TYPE都为2，id不同，可能为101、102、103
